module.exports = __webpack_public_path__ + "img/translationeditor_2.949570d4.jpg";